import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { HeightLimitedExpander } from 'cat-ecommerce-alloy';
import PropTypes from 'prop-types';
import { replaceTokensInString } from '../../../../utils';
import PurifiedHtml from '@app/components/common/PurifiedHtml';
import Prop65Warning from '../../../common/product/Prop65Warning';
import HoseWarning from '../../../common/product/HoseWarning';
import NonReturnablePartIndicator from '../../../common/product/NonReturnablePartIndicator';
import { DESCRIPTION_ID } from '../constants';

const ProductDescription = ({ productId }) => {
  const [t] = useTranslation();

  const longDescription = useSelector(
    s => s.products?.byId?.[productId]?.longDescription
  );
  const prop65Warning = useSelector(s => s.products?.byId?.[productId]?.prop65);
  const hoseWarning = useSelector(
    s => s.products?.byId?.[productId]?.hoseWarning
  );
  const partNumber = useSelector(
    s => s.products?.byId?.[productId]?.partNumber || ''
  );
  const isNonReturnable = useSelector(
    s => s.products.priceAndAvailability?.[partNumber]?.nonReturnable
  );
  const isDescriptionAvailable =
    longDescription || isNonReturnable || prop65Warning;

  const descriptionTitle = replaceTokensInString(
    t('PDP_DESC_FOR_PART'),
    partNumber
  );

  return (
    <section className="py-3" id={DESCRIPTION_ID}>
      <h2 className="h3 display-3">{descriptionTitle}</h2>
      {isDescriptionAvailable ? (
        <>
          <HeightLimitedExpander
            buttonSize="large"
            id="descriptionExpander"
            lessButtonText={t('VIEW_LESS')}
            moreButtonText={t('VIEW_MORE_PRODUCTS')}
          >
            {longDescription && (
              <PurifiedHtml as="p" htmlString={longDescription} />
            )}
          </HeightLimitedExpander>
          {isNonReturnable && <NonReturnablePartIndicator />}
          {prop65Warning && <Prop65Warning message={prop65Warning} />}
          {hoseWarning && <HoseWarning message={hoseWarning} />}
        </>
      ) : (
        <p>{t('PART_DESCRIPTION_INFORMATION_NOT_AVAILABLE')}</p>
      )}
    </section>
  );
};

ProductDescription.propTypes = {
  productId: PropTypes.string
};

export default ProductDescription;
